import * as _ from 'lodash'
import React from 'react';
import contractProxy from '../models/contractProxy';
import * as contractorActions from '../contractorActions';
import * as employeeActions from '../employeeActions';
import componentServices from '../componentServices';
import util from '../util';
import globalRelay from '../globalRelay';
import JobCostSummary from '../models/jobCostSummary';
import { Expander, sortableComponent } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from '../store';

class JobContractTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick () {
		const { item } = this.props;
		if (item.changeKey) {
			componentServices.router.pushHistory(componentServices.router.pushPathSegments(item.contractKey, item.model.type, item.changeKey, 'setup'));
		}
		else {
			componentServices.router.pushHistory(componentServices.router.pushPathSegments(item.contractKey, 'setup'));
		}
	}

	render () {
		const { item } = this.props;
		const globalConfig = globalRelay.config!.withVariant(item.companyVariant);
		const numberRow = globalRelay.config!.variants.length > 1 && globalConfig.badge ? <td>{item.relayNumber} <span className="badge" style={{ backgroundColor: globalConfig.badge.color }}><span>{ globalConfig.badge.label }</span></span></td> : <td>{item.relayNumber}</td>;
		const rowClasses = [item.type.toLowerCase()];
		const status = item.status || { status: 'unknown' };
		let statusLabel = '';

		if (status.status === 'pending-approval') {
			rowClasses.push('submitted');
			statusLabel = 'Submitted to Order Desk';
		}
		else if (status.status === 'locked') {
			rowClasses.push('submitted');
			statusLabel = 'Finalized';
		}
		else if (status.status === 'rejected') {
			rowClasses.push('rejected');
			statusLabel = 'Rejected by Order Desk';
		}
		else if (status.status === 'approved') {
			rowClasses.push('finalized');
			statusLabel = 'Accepted';
		}
		else if (status.status === 'unlocked' && status.description === 'audit-requested') {
			rowClasses.push('submitted');
			statusLabel = 'Audit Requested';
		}
		else if(status.status === 'closed'){
			rowClasses.push('closed');
			statusLabel = 'Closed';
		}
		else {
			rowClasses.push('draft');
			statusLabel = 'Draft';
		}

		return (

			<tr className={ rowClasses.join(' ') } onClick={ this.handleClick }>
				<td />
				<td className="status">{ statusLabel }</td>
				<td>{ item.type }</td>
				<td>{ item.name }</td>
				<td className="sell">{util.formatAsCurrency(item.sell)}</td>
				<td>{ item.createdBy || '-' }</td>
				<td>{ item.statusOwner || '-' }</td>
				<td>{ item.statusDate ? util.dateHelper.formatDate(item.statusDate, { userFriendly: true }) : '-'}</td>
				<td>{ item.accountingId }</td>
				{ numberRow }
				<td />
				<td />
			</tr>
		);
	}
}

const JobContractTable = sortableComponent(class ContractTable extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();
		this.props.updateSort(path);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, store, ...childProps } = this.props;
		const rows:JSX.Element[] = [];

		list.forEach(item => {
			rows.push(<JobContractTableRow item={item} key={item.model.key} store={ store} {...childProps} />);
		});

		return (
			<table className="sortable interactive" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={'status ' + this.getClassName('status')} onClick={this.handleClick.bind(this, 'status')}>Status</td>
						<td className={this.getClassName('type')} onClick={this.handleClick.bind(this, 'type')}>Type</td>
						<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Name</td>
						<td className={'sell ' + this.getClassName('sell')} onClick={this.handleClick.bind(this, 'sell')}>Sell</td>
						<td className={this.getClassName('createdBy')} onClick={this.handleClick.bind(this, 'createdBy')}>Created by</td>
						<td className={this.getClassName('statusOwner')} onClick={this.handleClick.bind(this, 'statusOwner')}>Reviewed by</td>
						<td className={this.getClassName('statusDate')} onClick={this.handleClick.bind(this, 'statusDate')}>Reviewed on</td>
						<td className={this.getClassName('accountingId')} onClick={this.handleClick.bind(this, 'accountingId')}>{ globalRelay.config!.getString('Accounting ID','job') }</td>
						<td className={this.getClassName('relayNumber')} onClick={this.handleClick.bind(this, 'relayNumber')}>Relay No.</td>
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{ rows }
				</tbody>
			</table>
		);
	}
});

export default class JobContractsList extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = JobContractsList.getDerivedStateFromProps(props, {});
	}

	static getDerivedStateFromProps (props, currentState) {
		const { job } = props;
		const { store } = componentServices;
		const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });
		const state = _.assign({}, currentState);
		const contracts:any[] = [];
		const laterDate = new Date(Date.now() + (365 * 24 * 60 * 60 * 100)); // this sorts non-accepted contracts to the end
		const resolveReviewStatus = (statusLogged) => {
			let result = statusLogged.getMostRecentStatusByStatus(['approved', 'rejected', 'pending-approval', 'closed']);

			if (result) {
				const lastUnlocked = statusLogged.getMostRecentStatusByStatus(['unlocked']);

				if (lastUnlocked && lastUnlocked.dateCreated > result.dateCreated) {
					if (lastUnlocked.description === 'audit-requested') {
						result = lastUnlocked; // this was unlocked for audit
					}
					if (result.status === 'closed') {
						result = lastUnlocked; // this was a closed change order that was opened
					}
				}
			}

			if (statusLogged.currentStatusItem && statusLogged.currentStatusItem.status === 'unlocked' && statusLogged.currentStatusItem.description === 'audit-requested') {
				result = statusLogged.currentStatusItem;
			}

			return result;
		};

		if (jobCosts && jobCosts.size) {
			jobCosts
				.filter(jc => jc.jobKey === job.key && jc.isContract)
				.forEach(jc => {
					let proxy = contractProxy(jc, undefined, true);
					let reviewStatus = resolveReviewStatus(proxy);
					let createdBy = employeeActions.getEmployeeByUserKey(jc.createdById);
					let statusOwner = reviewStatus ? employeeActions.getEmployeeByUserKey(reviewStatus.createdById) : undefined;
					let summary = new JobCostSummary(proxy, job.getAppliedPaymentTotal(proxy.key));
					summary.buildItems();

					const contract = {
						type: 'Contract',
						contractKey: proxy.key,
						model: proxy,
						status: reviewStatus,
						name: proxy.name,
						sell: summary.grandTotalSell,
						createdBy: createdBy && createdBy.fullName,
						statusOwner: statusOwner && statusOwner.fullName,
						statusDate: reviewStatus && reviewStatus.status !== 'pending-approval' ? reviewStatus.dateCreated : undefined,
						accountingId: proxy.accountingId,
						relayNumber: proxy.relayNumber,
						companyVariant: proxy.companyVariant,
						changeOrders: [] as any[]
					};

					_.forEach(proxy.changeOrders, co => {
						proxy = contractProxy(jc, co, true);
						createdBy = employeeActions.getEmployeeByUserKey(co.createdById);
						reviewStatus = resolveReviewStatus(co);
						statusOwner = reviewStatus ? employeeActions.getEmployeeByUserKey(reviewStatus.createdById) : undefined;
						summary = new JobCostSummary(proxy, job.getAppliedPaymentTotal(co.key));
						const isPreviouslySubmitted = co.getMostRecentStatusByStatus(['rejected', 'pending-approval']);
						summary.buildItems();

						contract.changeOrders.push({
							type: _.startCase(co.type),
							contractKey: proxy.key,
							changeKey: co.key,
							model: co,
							status: reviewStatus,
							name: co.name,
							sell: summary.grandTotalSell,
							createdBy: createdBy && createdBy.fullName,
							statusOwner: isPreviouslySubmitted && statusOwner && statusOwner.fullName,
							statusDate: isPreviouslySubmitted && reviewStatus && reviewStatus.status !== 'pending-approval' ? reviewStatus.dateCreated : undefined,
							accountingId: co.accountingId,
							relayNumber: co.relayNumber,
							companyVariant: proxy.companyVariant,
							isContract: co.isContract
						});
					});

					_.sortBy(contract.changeOrders, 'dateCreated');

					contracts.push(contract);
				});
		}

		if (job.builderKey) {
			if (!state.builder || state.builder.key !== job.builderKey) {
				state.builder = getModel({ store, collection: ModelCollection.contractors, key: job.builderKey });
				if (!state.builder) {
					if (state.fetchedBuilderKey !== job.builderKey) {
						// this prevents endless fetch calls if the builder somehow went missing
						state.fetchedBuilderKey = job.builderKey;
						contractorActions.fetchContractor({ key: job.builderKey });
					}
				}
				else {
					state.fetchedBuilderKey = undefined;
				}
			}
		}
		else {
			state.builder = undefined;
		}

		state.job = job;
		state.contracts = _.sortBy(contracts, c => c.statusDate || laterDate);

		return state;
	}

	handleAddChangeClick (contractKey, type) {
		componentServices.router.pushHistory(componentServices.router.pushPathSegments(contractKey, type, util.generateGuid()));
	}

	handleCompositeContractClick (contractKey) {
		componentServices.router.pushHistory(componentServices.router.pushPathSegments(contractKey, 'composite'));
	}

	render () {
		const { contracts } = this.state;
		const expanders = _.map(contracts, contract => {
			const list = _.concat([contract], contract.changeOrders);
			const title = `Contract - ${contract.name}`;
			const buttonClass = contract.status.status !== 'approved' ? 'disabled' : '';
			const compositeButtonClass = contract.changeOrders.some(co => co.isContract)? '': 'disabled';

			return 	(<Expander key={ contract.model.key } title={title} contentClassNames={['inner']}>
				<JobContractTable list={list} initialSortKey="status" />
				<button className={ `iconLabel addChange ${buttonClass}` } onClick={ this.handleAddChangeClick.bind(this, contract.contractKey, 'change-order')}><span>Make Changes</span></button>
				<button className={ `iconLabel addBillingAdjustment ${buttonClass}` } onClick={ this.handleAddChangeClick.bind(this, contract.contractKey, 'billing-adjustment')}><span>Billing Adjustment</span></button>
				<button className={ `iconLabel viewCompositeContract ${compositeButtonClass}` } onClick={ this.handleCompositeContractClick.bind(this, contract.contractKey)}><span>View Composite Contract</span></button>
			</Expander>);
		});

		return (
			<div>
				{ expanders }
			</div>
		);
	}
}
